export enum Flag {
  CONSONANT = 1,
  VOWEL = 2,
  DIPTHONG = 4,
  NOT_FIRST = 8
}
